var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCategoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 49,
    viewBox: "0 0 50 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 49,
    rx: 8,
    fill: "#12B1B4",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 17.5H19C18.1716 17.5 17.5 18.1716 17.5 19V21C17.5 21.8284 18.1716 22.5 19 22.5H21C21.8284 22.5 22.5 21.8284 22.5 21V19C22.5 18.1716 21.8284 17.5 21 17.5ZM19 16C17.3431 16 16 17.3431 16 19V21C16 22.6569 17.3431 24 19 24H21C22.6569 24 24 22.6569 24 21V19C24 17.3431 22.6569 16 21 16H19Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 27.5H19C18.1716 27.5 17.5 28.1716 17.5 29V31C17.5 31.8284 18.1716 32.5 19 32.5H21C21.8284 32.5 22.5 31.8284 22.5 31V29C22.5 28.1716 21.8284 27.5 21 27.5ZM19 26C17.3431 26 16 27.3431 16 29V31C16 32.6569 17.3431 34 19 34H21C22.6569 34 24 32.6569 24 31V29C24 27.3431 22.6569 26 21 26H19Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31 17.5H29C28.1716 17.5 27.5 18.1716 27.5 19V21C27.5 21.8284 28.1716 22.5 29 22.5H31C31.8284 22.5 32.5 21.8284 32.5 21V19C32.5 18.1716 31.8284 17.5 31 17.5ZM29 16C27.3431 16 26 17.3431 26 19V21C26 22.6569 27.3431 24 29 24H31C32.6569 24 34 22.6569 34 21V19C34 17.3431 32.6569 16 31 16H29Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31 27.5H29C28.1716 27.5 27.5 28.1716 27.5 29V31C27.5 31.8284 28.1716 32.5 29 32.5H31C31.8284 32.5 32.5 31.8284 32.5 31V29C32.5 28.1716 31.8284 27.5 31 27.5ZM29 26C27.3431 26 26 27.3431 26 29V31C26 32.6569 27.3431 34 29 34H31C32.6569 34 34 32.6569 34 31V29C34 27.3431 32.6569 26 31 26H29Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryIcon);
export default __webpack_public_path__ + "static/media/category-icon.f66802ae907d964869365fddb066c228.svg";
export { ForwardRef as ReactComponent };